module.exports = new __parcel__URL__("changing-landscapes--cover.311d1b40.jpg").toString();